import PropTypes from 'prop-types';
import React from 'react';

const DetalhesDestino = ({ destino }) => (
  <>
    <p>
      <b>Recebedor</b>
    </p>
    <p>
      <b>Cliente: </b>
      <span>
        {destino.nome_recebedor ? destino.nome_recebedor : 'Não informado'}
      </span>
    </p>
    <p>
      <b>Cidade: </b>
      <span>
        {destino.cidade_recebedor
          ? `${destino.cidade_recebedor} - `
          : 'Não informado'}
      </span>
      <span>{destino.estado_recebedor ? destino.estado_recebedor : ''}</span>
    </p>
    <br />
    <p>
      <b>Destinatário</b>
    </p>
    <p>
      <b>Cliente: </b>
      <span>
        {destino.nome_destinatario
          ? destino.nome_destinatario
          : 'Não informado'}
      </span>
    </p>
    <p>
      <b>Cidade: </b>
      <span>
        {destino.cidade_destinatario
          ? `${destino.cidade_destinatario} - `
          : 'Não informado'}
      </span>
      <span>
        {destino.estado_destinatario ? destino.estado_destinatario : ''}
      </span>
    </p>
  </>
);

DetalhesDestino.propTypes = {
  destino: PropTypes.shape({
    nome_recebedor: PropTypes.string,
    cidade_recebedor: PropTypes.string,
    estado_recebedor: PropTypes.string,
    nome_destinatario: PropTypes.string,
    cidade_destinatario: PropTypes.string,
    estado_destinatario: PropTypes.string,
  }),
};

DetalhesDestino.defaultProps = {
  destino: {},
};

export default DetalhesDestino;
